import TextCaption3 from "./TextCaption3.js";
export default TextCaption3;
//# sourceMappingURL=index.js.map